import Vue from 'vue'
import {getBlob} from "@/plugins/axios";
import {parseTime} from "@/utils";

// 订单详情获取
export function getOrderDetail(data) {
  return Vue.axios({
    url: '/api/order/get_info',
    method: 'get',
    params: {...data,}

  })
}

// 订单详情-基本信息
export function getOrderDetailBase(data) {
  return Vue.axios({
    url: '/api/order/detail_base',
    method: 'get',
    params: {...data,}

  })
}

// 订单详情-获取订单部分信息
export function getOrderPartInfo(id, op) {
  return Vue.axios({
    url: '/api/order/get_part_info',
    method: 'post',
    data: {id: id, op: op}

  })
}

// 订单详情-执行部分信息
export function getOrderDetailExec(data) {
  return Vue.axios({
    url: '/api/order/detail_exec',
    method: 'get',
    params: {...data,}

  })
}

/**
 * 执行订单
 * @param data
 * @returns {*}
 */
export function execOrder(data) {
  return Vue.axios({
    url: '/api/order/exec_order',
    method: 'post',
    data: {...data,}

  })
}

/**
 * 执行订单
 * @param data
 * @returns {*}
 */
export function rollBackExecOrder(data) {
  return Vue.axios({
    url: '/api/order/rollback_exec',
    method: 'post',
    data: {...data,}

  })
}

// 订单详情-回款信息
export function getOrderDetailAccount(data) {
  return Vue.axios({
    url: '/api/order/detail_account',
    method: 'get',
    params: {...data,}

  })
}

//推荐分成
export function getOrderRateRecommend(data) {
  return Vue.axios({
    url: '/api/order/rate_recommend',
    method: 'get',
    params: {...data,}

  })
}

//订单发票号列表
export function getOrderInvoiceNumberList(data) {
  return Vue.axios({
    url: '/api/order_invoice_number/queryByOrderId',
    method: 'get',
    params: {...data,}

  })
}

//添加订单发票号码
export function addOrderInvoiceNumber(data) {
  return Vue.axios({
    url: '/api/order_invoice_number/add',
    method: 'post',
    data: {...data,}
  })
}

// 批量添加订单发票号码
export function batchStoreOrderInvoiceNumber(data) {
  return Vue.axios({
    url: '/api/order_invoice_number/batchStore',
    method: 'post',
    data: {...data,}
  })
}

//删除订单发票记录
export function delOrderInvoiceNumber(data) {
  return Vue.axios({
    url: '/api/order_invoice_number/delete',
    method: 'post',
    data: {...data,}
  })
}

//订单分成比例修改
export function editOrderRate(data) {
  return Vue.axios({
    url: '/api/order/edit_rate',
    method: 'post',
    data: {...data,}
  })
}


// 保存订单信息
export function saveOrder(data) {
  return Vue.axios({
    url: '/api/order/save',
    method: 'post',
    data: {...data,}

  })
}

//下载订单模板
export function downloadOrderTemplate() {
  let t = (new Date()).getMilliseconds()
  return getBlob('/api/orders/downImportTemplate', {t: t});
}

// 创建订单
export function createOrder(data) {
  return Vue.axios({
    url: '/api/order/save_order',
    method: 'post',
    data: {...data}
  })
}

//全案营销订单合并前数据预览
export function preMergeOrders(data) {
  return Vue.axios({
    url: '/api/order/pre_merge_orders',
    method: 'post',
    data: {...data}
  })
}

//保存合并的全案营销订单
export function saveMergeOrders(data) {
  return Vue.axios({
    url: '/api/order/save_merge_orders',
    method: 'post',
    data: {...data}
  })
}

// 创建订单-营销订单主单
export function saveOrderWcmMain(data) {
  return Vue.axios({
    url: '/api/order/save_order_wcm',
    method: 'post',
    data: {...data}
  })
}

// 查询指定订单开票记录
export function queryInvoiceRecordByOrderId(params) {
  return Vue.axios({
    url: '/api/order_invoice_record/queryByOrderId',
    method: 'get',
    params
  })
}


// 订单开票记录删除
export function invoiceRecordDestroy(data) {
  return Vue.axios({
    url: '/api/order_invoice_record/destroy',
    method: 'post',
    data
  })
}

// 暂存订单保存
export function temporariesSave(data) {
  return Vue.axios({
    url: '/api/order/temporaries_save',
    method: 'post',
    data
  })
}

// 暂存订单列表
export function temporariesList() {
  return Vue.axios({
    url: '/api/order/temporaries_list',
    method: 'get'
  })
}

//revoke_contract 【撤销】订单的合同归档
export function revokeOrderContract(data) {
  return Vue.axios({
    url: '/api/order/revoke_contract',
    method: 'post',
    data
  })
}

// 直播数据列表查询
export function getOrderLiveDataList(data) {
  return Vue.axios({
    url: '/api/order_live_data/getList',
    method: 'post',
    data
  })
}

// 直播数据新增修改保存
export function saveOrderLiveData(data) {
  return Vue.axios({
    url: '/api/order_live_data/store',
    method: 'post',
    data
  })
}

// 直播数据删除
export function deleteOrderLiveData(data) {
  return Vue.axios({
    url: '/api/order_live_data/delete',
    method: 'post',
    data
  })
}

// 直播记录统计
export async function reportOrderLiveData(params) {
  const response = await Vue.axios({
    url: '/api/order_live_data/report',
    method: 'get',
    params
  })

  const table = response && response.model && response.model.data ? response.model.data : []
  table.map(row => {
    // 直播月份
    row._live_date = row.live_date ? parseTime(row.live_date, '{y}年{m}月') : ''
    // 是否保量
    row._is_quantity = row.is_quantity === 'Y' ? '是' : (row.is_quantity === 'N' ? '否' : '')
    // 是否保次数
    row._is_quantity_times = row.is_quantity_times === 'Y' ? '是' : (row.is_quantity_times === 'N' ? '否' : '')
    // 对应子订单发布平台
    row._platforms = row.platforms ? row.platforms.join(',') : ''
  })
  response.model.data = table
  return response
}

// 直播数据脚本
export function runReportOrderLiveScript(data) {
  return Vue.axios({
    url: '/api/order_live_data/runScript',
    method: 'post',
    data
  })
}

//全案营销-是否完结保存接口

export function saveWcmOrderStatus(params) {
  return Vue.axios({
    url: '/api/order/done_wcm_order',
    method: 'get',
    params: {...params}
  })
}

/**
 * 修改合作形式
 * @param data
 * @returns {*}
 */
export function changeCooperation(data) {
  return Vue.axios({
    url: '/api/order/change_cooperation',
    method: 'post',
    data
  })
}

/**
 * 获取红人分成比例
 * @param params
 * @return {*}
 */
export function getArtistRebateRate(params) {
  return Vue.axios({
    url: '/api/orders/getArtistRebateRate',
    method: 'get',
    params
  })
}
